let loadPromise = null;

export default {
  init: function () {
    const AK = "d89dd2c4a05edf4e1c1694ad2094d2af";
    // 设置安全密钥
    window._AMapSecurityConfig = {
      securityJsCode: "4c1e92625a9bf3bc2721d43a1d4e6443",
    };

    // 已加载直接返回
    if (typeof AMap !== "undefined") {
      return Promise.resolve(AMap);
    }
    // 并发 init 只插一次 script，共用同一个 Promise
    if (loadPromise) {
      return loadPromise;
    }

    const AMap_URL =
      "https://webapi.amap.com/maps?v=2.0&key=" +
      AK +
      "&callback=onMapCallback&plugin=AMap.PlaceSearch,AMap.AutoComplete,AMap.Geocoder,AMap.GeometryUtil,AMap.MouseTool";

    loadPromise = new Promise((resolve, reject) => {
      window.onMapCallback = function () {
        resolve(AMap);
      };

      let scriptNode = document.createElement("script");
      scriptNode.setAttribute("type", "text/javascript");
      scriptNode.setAttribute("src", AMap_URL);
      scriptNode.onerror = function () {
        loadPromise = null;
        reject(new Error("AMap script load failed"));
      };
      document.body.appendChild(scriptNode);
    });

    return loadPromise;
  },
};
